import { IHeaderColumn } from 'Components/TableBase/SortableTableHead';

export enum EActivitiesTableColumnKeys {
  TITLE = 'title',
  PARTNER = 'partner',
  MODIFIED_TIMESTAMP = 'modifiedTimestamp',
  ACTIONS = 'actions',
}

export const activitiesHeaderColumns: IHeaderColumn<EActivitiesTableColumnKeys>[] = [
  { id: EActivitiesTableColumnKeys.TITLE, headerName: 'Title', sortable: false },
  {
    id: EActivitiesTableColumnKeys.PARTNER,
    headerName: 'Owner',
    sortable: false,
  },
  {
    id: EActivitiesTableColumnKeys.MODIFIED_TIMESTAMP,
    headerName: 'Last edited',
    sortable: false,
  },
  { id: EActivitiesTableColumnKeys.ACTIONS, headerName: 'Actions', sortable: false, align: 'left' },
];
